function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function calculateTotalPrice(state){
  // Base bikes + extras + pedals
  const bikesTotal = (state?.bikes || []).reduce((prev, next) => {
    const extrasTotal = (next?.extras || []).reduce((p, n) => p + (n?.total_price || 0), 0)
    const pedalsPrice = next?.pedals?.price || 0
    return prev + (next?.price || 0) + extrasTotal + pedalsPrice
  }, 0)

  const delivery = Number(state?.deliveryPrice || 0)
  const subtotal = bikesTotal + delivery

  // Apply discount if present
  if (state?.discount_code_id && !!state?.discount?.id) {
    const type = state?.discount?.type
    const value = Number(state?.discount?.discount || 0)

    if (type === 'percent') {
      const discountAmount = Math.max(0, Math.min(subtotal, (subtotal * value) / 100))
      return Math.max(0, subtotal - discountAmount)
    }
    if (type === 'fixed') {
      const discountAmount = Math.max(0, Math.min(subtotal, value))
      return Math.max(0, subtotal - discountAmount)
    }
  }

  return subtotal
}

export {validateEmail, calculateTotalPrice}